







































import { Component } from 'vue-property-decorator';
import CoinInformationCard from '@/components/ViewComponent/Exchange/CoinInformationCard.vue';
import CSideBar from '@/components/Layout/SideBar/CSideBar.vue';
import { ProductCategoryEntity } from '@/entities/product-category.entity';
import { UseService } from '@/services/service';
import ProductCategoryService from '@/services/product-category.service';
import HasSideDrawerMixin from '@/mixin/Layout/has-side-drawer-mixin';

@Component<Exchange>({
  components: {
    CoinInformationCard,
    CSideBar,
  },
})
export default class Exchange extends HasSideDrawerMixin {
  categories: Partial<ProductCategoryEntity>[] = [];

  @UseService(ProductCategoryService)
  categoryService: ProductCategoryService;

  async created(): Promise<void> {
    [this.categories] = await this.categoryService.apiBuilder.getMany();
  }
}
